import { THEMES } from './themes.ts';
import { useTheme } from './useTheme.ts';
import { Focusable } from '@/ui/Focusable.tsx';

/**
 * Swatch chips, or dialog rows. See BufferPicker for why these are two
 * renderings rather than one rendering with overrides.
 */
export function ThemePicker({
  onPicked, variant = 'chip',
}: {
  onPicked?(): void;
  variant?: 'chip' | 'row';
} = {}) {
  const { theme, setTheme } = useTheme();
  const row = variant === 'row';

  return (
    <div className={row ? 'menu-items' : 'themepicker'} role="group" aria-label="Theme">
      {THEMES.map((t) => (
        <Focusable
          key={t.id}
          id={`theme-${t.id}`}
          onSelect={() => { setTheme(t.id); onPicked?.(); }}
          className={row
            ? `btn menu-item ${theme === t.id ? 'active' : ''}`
            : `swatch ${theme === t.id ? 'active' : ''}`}
        >
          <span className="chips" aria-hidden="true">
            <i style={{ background: t.swatch[0] }} />
            <i style={{ background: t.swatch[1] }} />
            <i style={{ background: t.swatch[2] }} />
          </span>
          <span className="label">{t.name}</span>
        </Focusable>
      ))}
    </div>
  );
}
